// @flow
import * as React from "react"
import * as Util from "../common"
import {containers} from "@swarm2/core"
import {throws} from "@swarm2/assert"
import CombatRun from "./CombatRun"
import CombatResult from "./CombatResult"

function CombatMainRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {isEmpty, isRunning, isDone, charId, clientNow} = props
  if (isEmpty) return <Util.NotFoundView title="no-combat" />
  if (isRunning) {
    return <CombatRun charId={charId} clientNow={clientNow} />
  }
  if (isDone) {
    return <CombatResult charId={charId} clientNow={clientNow} />
  }
  return throws(
    "CombatMain: invalid combat state: not empty, running, or done",
    props,
  )
}
export default containers.combat.CombatMain(Util.DumpProps(CombatMainRender))



// WEBPACK FOOTER //
// ./src/combat/CombatMain.js